import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faHandHoldingUsd, faMoneyBillWave, faUserShield } from '@fortawesome/free-solid-svg-icons';
import HeroSection from '../components/HeroSection';
import ContactSection from '../components/ContactSection';

const FinancePage: React.FC = () => {
  return (
    <>
      <HeroSection 
        title="आर्थिक सेवा"
        subtitle="जीवन आधार महिला ग्रामीण बिगरशेती पतसंस्था - आर्थिक समावेशनाद्वारे समुदायांना सक्षम बनवणे"
        buttonText="अधिक जाणून घ्या"
        buttonLink="#services"
      />
      
      <section className="section">
        <Container>
          <Row className="align-items-center mb-5">
            <Col lg={6} className="mb-4 mb-lg-0">
              <h2>जीवन आधार महिला ग्रामीण बिगरशेती पतसंस्था</h2>
              <p className="lead">ग्रामीण समुदायांसाठी आर्थिक सशक्तीकरण</p>
              <p>
                आमची वित्तीय संस्था ग्रामीण भागातील लोकांना, विशेषतः महिलांना, आर्थिक सेवा सुलभतेने
                उपलब्ध करून देण्यासाठी कार्य करते. आम्हाला विश्वास आहे की आर्थिक समावेश हा आर्थिक विकासाचा
                आणि सामाजिक प्रगतीचा प्रभावी मार्ग आहे.
              </p>
              <p>
                किशोर साळगर यांच्या स्थापनेने सुरु झालेली आमची संस्था स्पर्धात्मक व्याजदरावर कर्जे
                उपलब्ध करून देत असून, व्यक्तींना आणि कुटुंबांना त्यांचे आर्थिक उद्दिष्टे साध्य करण्यात
                मदत करते.
              </p>
              <p>
                आम्ही आर्थिक सेवा, शिक्षण व मार्गदर्शन यांचा समन्वय करून ग्राहकांना योग्य निर्णय घेण्यासाठी
                आवश्यक ज्ञान व साधने पुरवतो.
              </p>
            </Col>
            <Col lg={6}>
              <div className="bg-light-gray p-4 rounded">
                <h4 className="mb-4">आमच्या आर्थिक सेवा</h4>
                <Row>
                  <Col md={6} className="mb-3">
                    <div className="d-flex">
                      <div className="me-3 text-primary">
                        <FontAwesomeIcon icon={faHandHoldingUsd} size="2x" />
                      </div>
                      <div>
                        <h5>स्पर्धात्मक कर्ज योजना</h5>
                        <p className="mb-0">सुलभ व किफायतशीर अटींवर कर्ज उपलब्ध</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="d-flex">
                      <div className="me-3 text-primary">
                        <FontAwesomeIcon icon={faMoneyBillWave} size="2x" />
                      </div>
                      <div>
                        <h5>बचत योजना</h5>
                        <p className="mb-0">आकर्षक परताव्यासह सुरक्षित बचत पर्याय</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="d-flex">
                      <div className="me-3 text-primary">
                        <FontAwesomeIcon icon={faChartLine} size="2x" />
                      </div>
                      <div>
                        <h5>आर्थिक नियोजन</h5>
                        <p className="mb-0">तुमच्या आर्थिक प्रवासासाठी तज्ञ मार्गदर्शन</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="d-flex">
                      <div className="me-3 text-primary">
                        <FontAwesomeIcon icon={faUserShield} size="2x" />
                      </div>
                      <div>
                        <h5>सुरक्षित व्यवहार</h5>
                        <p className="mb-0">सुरक्षित व पारदर्शक आर्थिक व्यवहार</p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      
      <section className="section bg-light-gray" id="services">
        <Container>
          <h2 className="section-title">आमचे आर्थिक उपाय</h2>
          <p className="section-subtitle">आर्थिक समावेशनाद्वारे समाज सक्षम करणे</p>
          
          <Row className="g-4 mt-4">
            <Col lg={4} md={6}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>महिला सक्षमीकरण कर्ज</Card.Title>
                  <Card.Text>
                    महिलांना व्यवसाय सुरु किंवा वाढविण्यासाठी खास डिझाइन केलेली कर्ज योजना, लवचिक परतफेडीच्या अटींसह व कमी व्याजदरासह.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>शेती कर्ज</Card.Title>
                  <Card.Text>
                    शेतकऱ्यांना यंत्रसामग्री, बियाणे व शेतीसाठी लागणाऱ्या गोष्टींसाठी आर्थिक मदत, उत्पादन व उत्पन्न वाढविण्यासाठी.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>शैक्षणिक कर्ज</Card.Title>
                  <Card.Text>
                    शिक्षणासाठी आर्थिक मदत, जेणेकरून आर्थिक अडचणी शिक्षणात अडथळा ठरू नयेत.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>गृहसुधार कर्ज</Card.Title>
                  <Card.Text>
                    घर दुरुस्ती, नूतनीकरण व सुधारणा यासाठी आर्थिक मदत, राहणीमान व मालमत्तेचे मूल्य वाढवण्यासाठी.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>लघुउद्योग कर्ज</Card.Title>
                  <Card.Text>
                    लघुउद्योग व उद्योजकांना व्यवसाय सुरू किंवा वाढविण्यासाठी मदत, रोजगारनिर्मिती व आर्थिक वाढीसाठी.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>आर्थिक साक्षरता कार्यक्रम</Card.Title>
                  <Card.Text>
                    आर्थिक ज्ञान व कौशल्य वाढवण्यासाठी शैक्षणिक उपक्रम, जे व्यक्तींना योग्य आर्थिक निर्णय घेण्यास सक्षम करतात.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      
      <ContactSection />
    </>
  );
};

export default FinancePage;
